export default __webpack_public_path__ + "static/media/bar.925b5793.jpg";